export default __webpack_public_path__ + "static/media/menu.fa82e76e.svg";